<template>
    <div id="addDeal">
      <div class="info_form" v-if="!isServiceDeal">
        <div class="title"><div class="circle"></div>{{$t('deal.addDeal.dealSource.title')}}</div>
        <div>
          <a-form :form="dealSourceForm" layout="vertical">
            <a-row class="background_color">
              <a-col :span="8">
                <!-- 业务来源人 -->
                <a-form-item :label="$t('deal.addDeal.dealSource.sourceUsers')" class="required">
                  <pt-user-select
                    :maxTagTextLength="3"
                    v-decorator="decorators.dealSourcePersonStringList" :placeholder="$t('deal.addDeal.errorInfo.dealSourcePersonStringList')"  style="width: 150px" mode="multiple" maxTagCount="1"></pt-user-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <!-- 来源途径 -->
                <a-form-item :label="$t('deal.addDeal.dealSource.sourceType')" class="required">
                  <pt-select v-decorator="decorators.dealSourceTree" :allowClear="false"
                             :placeholder="$t('deal.addDeal.errorInfo.dealSourceTree')">
                    <a-select-option v-for="d in leaseSourceTypeOptions" :key="d.wordKey" :value="d.wordKey">{{d.wordValue}}</a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <!-- 业务跟进人 -->
                <a-form-item :label="$t('deal.addDeal.dealSource.followers')" class="required">
                  <pt-user-select v-decorator="decorators.dealAccountList" :placeholder="$t('user.tips.select')"  style="width: 150px" mode="multiple" maxTagCount="1"
                                  :maxTagTextLength="3"></pt-user-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </div>
      <div class="info_form">
        <div class="title"><div class="circle"></div>{{$t('deal.addDeal.dealInfo')}}</div>
        <div v-if="!isServiceDeal" class="background_color">
          <a-form :form="dealVOForm" layout="vertical">
            <a-row>
              <a-col :span="16">
                <a-form-item :label="$t('deal.addDeal.dealDetails.companyName')" class="required">
                  <a-select
                    :disabled="leaseVO"
                    showSearch
                    v-decorator="decorators.customerId"
                    :placeholder="$t('deal.addDeal.dealDetails.companyName')"
                    :defaultActiveFirstOption="false"
                    :showArrow="false"
                    :filterOption="false"
                    @search="handleSearch"
                    :notFoundContent="null"
                    @change="buildProjectNameByCustomer"
                  >
                    <a-icon slot="suffixIcon" type="caret-down" />
                    <div slot="dropdownRender" slot-scope="menu">
                      <v-nodes :vnodes="menu" />
                      <a-divider style="margin: 0;" />
                      <div class="addCustomerBtn" @click="openAddCustomerModal">
                        <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                        <div style="font-size: 12px;color: #ffffff;margin-left:4px;">{{$t('track.trackModal.addCustomer')}}</div>
                      </div>
                    </div>
                    <a-select-option v-for="d in customerList" :key="d.id" :value="d.id">
                      <div style="display:flex;">
                        <div style="flex:1;" >
                          {{d.companyName}}
                        </div>
                        <div class="invisible-item">
                          {{d.companySortNameCn}}
                        </div>
                      </div>
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.tableHeader.companyName')">
                  <pt-input v-model="companyNameShort" :disabled="true"
                            :placeholder="$t('deal.addDeal.dealDetails.companyName')"></pt-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.propertyType')">
                  <ptSelect v-decorator="decorators.propertyType" :allowClear="false">
                    <a-select-option v-for="d in propertyTypes" :key="d.wordKey" :value="d.wordKey">{{d.wordValue}}</a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.demandArea')">
                  <a-input-group compact>
                    <pt-input-number style="width:70%;" v-decorator="decorators.demandArea" :max="9999999999" :precision="2" :min="0"></pt-input-number>
                    <pt-unit-select style="width: 30%;" type="area" v-decorator="decorators.demandAreaUnit" disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.budgetRent')">
                  <a-input-group compact>
                    <pt-input-number :precision="2" style="width:45%;" v-decorator="decorators.budgetRent" :max="999999" :min="0"></pt-input-number>
                    <pt-unit-select style="width: 55%;" type="rent" v-decorator="decorators.budgetRentUnit" disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div v-else class="background_color">
          <a-form :form="dealVOForm" layout="inline">
            <a-row>
              <a-form-item :label="$t('deal.addDeal.customerType')">
                <a-radio-group v-decorator="decorators.customerType" @change="customerTypeChange">
                  <a-radio :value="3">{{$t('dealConfirm.payerType.3')}}</a-radio>
                  <a-radio :value="1">{{$t('dealConfirm.payerType.1')}}</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-row>
          </a-form>
          <a-form :form="dealVOForm" layout="vertical">
            <a-form-item v-show="false">
              <a-input v-decorator="decorators.dealType">
              </a-input>
            </a-form-item>
            <a-row>
              <a-col :span="16">
                <a-form-item :label="$t('deal.addDeal.dealDetails.companyName')" class="required">
                  <a-select
                    :disabled="leaseVO"
                    showSearch
                    v-decorator="decorators.customerId"
                    :placeholder="$t('deal.addDeal.dealDetails.companyName')"
                    :defaultActiveFirstOption="false"
                    :showArrow="false"
                    :filterOption="false"
                    @search="handleSearch"
                    :notFoundContent="null"
                    @change="buildProjectNameByCustomer"
                  >
                    <a-icon slot="suffixIcon" type="caret-down" />
                    <div slot="dropdownRender" slot-scope="menu">
                      <v-nodes :vnodes="menu" />
                      <a-divider style="margin: 0;" />
                      <div class="addCustomerBtn" @click="openAddCustomerModal">
                        <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                        <div style="font-size: 12px;color: #ffffff;margin-left:4px;">{{customerType == 1 ? $t('track.trackModal.addCustomer') : $t('track.trackModal.addProprietor')}}</div>
                      </div>
                    </div>
                    <a-select-option v-for="d in customerList" :key="d.id" :value="d.id">
                      <div style="display:flex;">
                        <div style="flex:1;" class="invisible-item">
                          {{d.companyName}}
                        </div>
                        <div>
                          {{d.companySortNameCn}}
                        </div>
                      </div>
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectName')">
                  <a-input v-decorator="decorators.projectName"
                           :placeholder="$t('deal.addDeal.placeholder.projectName')"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealSource.sourceType')" class="required">
                  <pt-select v-decorator="decorators.dealSourceType" :allowClear="false"
                             :placeholder="$t('deal.addDeal.dealSource.sourceType')">
                    <a-select-option v-for="d in dealSourceTypeOptions" :key="d.wordKey" :value="d.wordKey">{{d.wordValue}}</a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectStages')">
                  <pt-select v-decorator="decorators.projectStages" :allowClear="false">
                    <a-select-option v-for="d in dealStages" :key="d.wordKey" :value="d.wordKey">{{d.wordValue}}</a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealSource.followers')" class="required">
                  <pt-user-select v-decorator="decorators.dealAccountList" :placeholder="$t('user.tips.select')"  style="width: 150px" mode="multiple" maxTagCount="1"
                                  :maxTagTextLength="3"></pt-user-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectPossible')">
                  <pt-slider
                    :blackhills-yellow="true"
                    :edit-mode="!disabled" :old-step="currProjectPossible"  @changeStep="changePossible" ref="possibleSliderRef"></pt-slider>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectEndtime')" class="required">
                  <pt-month-picker style="width:100%;" v-decorator="decorators.projectEndtime" :blackhillsYellow="true" :disabledDate="disabledMonthDate"></pt-month-picker>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.brokerage.totalBrokerage')">
                  <a-input-group compact>
                    <pt-input-number :precision="2" style="width:70%;" v-decorator="decorators.totalBrokerage"
                                     :blackhillsYellow="true"
                                     :max="99999999" :min="0"></pt-input-number>
                    <pt-unit-select style="width: 30%;" type="currency" v-decorator="decorators.totalBrokerageUnit" disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.priority')">
                  <ptSelect :placeholder="$t('track.trackModal.priorityTip')" v-decorator="decorators.priority" :allow-clear="false">
                    <a-select-option v-for="c in priorityOptions" :key="c.wordKey" :value="c.wordKey">
                      <span class="blackhillsYellow">{{c.wordValue}}</span>
                    </a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </div>
      <!-- 交易评估 -->
      <div  v-if="!isServiceDeal" class="info_form">
        <div class="title"><div class="circle"></div>{{$t('deal.addDeal.assessment')}}</div>
        <div v-if="!isServiceDeal" class="background_color">
          <a-form :form="dealVOForm" layout="vertical">
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectStages')">
                  <pt-select v-decorator="decorators.projectStages" :allowClear="false">
                    <a-select-option v-for="d in dealStages"   v-if="d.wordKey != 4" :key="d.wordKey" :value="d.wordKey">{{d.wordValue}}</a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.dealType')" class="required">
                  <ptSelect v-decorator="decorators.dealType" :allowClear="false" @change="buildProjectNameByDealType" mode="multiple"
                            :maxTagTextLength="2" :maxTagCount="2">
                    <a-select-option v-for="d in dealTypes" :key="d.wordKey">{{d.wordValue}}</a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectEndtime')" class="required">
                  <pt-month-picker style="width:100%;" v-decorator="decorators.projectEndtime" :blackhillsYellow="true" :disabledDate="disabledMonthDate"></pt-month-picker>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectPossible')">
                  <div class="slider-wrapper">
                    <pt-slider :edit-mode="!disabled" :old-step="currProjectPossible" @changeStep="changeBrokerageRatio" ref="possibleSliderRef"
                               blackhills-yellow="true"></pt-slider>
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.priority')">
                  <ptSelect :placeholder="$t('track.trackModal.priorityTip')" v-decorator="decorators.priority" :allow-clear="false">
                    <a-select-option v-for="c in priorityOptions" :key="c.wordKey" :value="c.wordKey"><span class="blackhillsYellow">{{c.wordValue}}</span></a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.brokerage.totalBrokerage')">
                  <a-input-group compact>
                    <pt-input-number :precision="2" style="width:70%;" :blackhills-yellow="true"
                                     :placeholder="$t('deal.addDeal.brokerage.totalBrokerageTips')"
                                     v-decorator="decorators.totalBrokerage" max="99999999" :min="0"></pt-input-number>
                    <pt-unit-select style="width: 30%;" type="currency" v-decorator="decorators.totalBrokerageUnit" disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col>
                <a-form-item :label="$t('deal.addDeal.dealDetails.competitionSituation')">
                  <ptSelect :maxTagCount="3" mode="multiple" v-model="colleagueList">
                    <a-select-option v-for="c in competitors" :key="c.id" :value="c.id" :disabled="!c.selectable">
                      <div style="display:flex;">
                        <div style="flex:1;" class="invisible-item">
                          {{c.companyName}}
                        </div>
                        <div>
                          {{c.companySortNameCn}}
                        </div>
                      </div>
                    </a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row class="deal_cascader">
              <a-col :span="24">
                <a-form-item :label="$t('deal.addDeal.dealDetails.targetArea')">
                  <pt-multi-cascader
                    v-decorator="decorators.targetArea"
                    :styleObj="{width: '100%'}"
                    size="small"
                    :options="cityDatas"
                    :props="{multiple: true}"
                    collapse-tags
                  ></pt-multi-cascader>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col>
                <a-form-item :label="$t('deal.addDeal.mansions')">
                  <div @click='openSelectMansion'>
                    <pt-select v-decorator='decorators.mansions'
                               :placeholder="$t('deal.addDeal.mansionsTip')"
                               :defaultActiveFirstOption='false'
                               :showArrow='false'
                               :filterOption='false'
                               :maxTagCount='3' :maxTagTextLength='13'
                               :notFoundContent='null'
                               mode='multiple'
                               @change='mansionChange'
                    >
                      <a-select-option v-for='m in mansionOptions' :key='m.id' :value='m.id'>{{ m.name }}
                      </a-select-option>
                    </pt-select>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-form-item :label="$t('deal.addDeal.brokerage.remarks')">
                <ptInput v-decorator="decorators.remarks" type="textarea" :autosize="{minRows:3,maxRows:3}"></ptInput>
              </a-form-item>
            </a-row>
          </a-form>
        </div>

      </div>

      <div v-if="!showLinkMan" class="info_form">
        <pt-addTag @showButton="showLinkManForm" :text="$t('deal.addDeal.linkMan.title')"></pt-addTag>
      </div>
      <div v-if="showLinkMan">
        <div class="title">
          <div class="circle"></div>{{$t('deal.addDeal.linkMan.title')}}
        </div>
        <div class="expandMoreDiv">
          <a-form :form="linkManDOForm"  layout="vertical" selfUpdate>
            <a-row v-for="(linkManForm,index) in linkManDOForms" v-bind:key="index">
              <a-col :span="6">
                <a-form-item :label="index == 0 ? $t('deal.addDeal.linkMan.name') : ''" class="required">
                  <a-input
                           v-decorator="[`linkmanDOS[${index}].name`,{rules: [
                {required: true,message: $t('linkman.modal.nameCNTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]"
                           :placeholder="$t('linkman.modal.nameCNTip')"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :label="index == 0 ? $t('deal.addDeal.linkMan.job') : ''">
                  <a-input
                    v-decorator="[`linkmanDOS[${index}].job`,{rules: [
                // {required: true,message: $t('linkman.modal.jobTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]"
                    :placeholder="$t('linkman.modal.jobTip')"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :label="index == 0 ? $t('deal.addDeal.linkMan.phone') : ''">
                  <a-input
                    v-decorator="[`linkmanDOS[${index}].phone`,{rules: [
                // {required: true,message: $t('linkman.modal.mobilePhoneTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                {pattern:/(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}/, message:$t('customer.customerModal.phoneErrorTip'), trigger: 'blur'},
                ],}]"
                    :placeholder="$t('linkman.modal.mobilePhoneTip')"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :label="index == 0 ? $t('deal.addDeal.linkMan.email') : ''">
                  <a-input
                    v-decorator="[`linkmanDOS[${index}].email`,{rules: [
                  {
                    type: 'email',
                    message:$t('customer.customerModal.emailErrorTip'),
                  },
                  {min: 2, max: 256, message: $t('customer.customerModal.textMaxLength'), trigger: 'blur'},
                ],}]"
                    :placeholder="$t('linkman.modal.emailTip')">
                    <div slot="addonAfter" @click="deleteLinkman(index)">
                      <pt-icon type="icon-tubiao" class="delete_icon"></pt-icon>
                    </div>
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
          <a-row>
            <a-form>
              <a-form-item>
                <pt-newObjectTag @click="addLinkMan"></pt-newObjectTag>
              </a-form-item>
            </a-form>
          </a-row>
        </div>
      </div>
      <template v-if="!isPursuitsToDeal">
        <div v-if="!isServiceDeal" class="title" style="display: flex;justify-content: space-between">
          <div>
            <div class="circle"></div>{{$t('deal.addDeal.leaseContract.title')}}
            <span style="color: #999999;font-size: 12px;font-weight: 400">({{$t('keydealTips')}})</span>
          </div>
        </div>
        <div v-if="!isServiceDeal" style="background: rgba(248,249,251,0.62);padding:10px 0px;margin-bottom: 10px;">
          <div  class="lease_info">
            <add-old-lease ref="oldLeaseRef" :defaultRentUnit="defaultRentUnit" :defaultLeaseInfoVO="defaultLeaseInfoVO == null ? defaultLeaseInfoVO : defaultLeaseInfoVO.leaseLeaseInfoVO" :defaultAreaUnit="defaultAreaUnit" ></add-old-lease>
          </div>
        </div>

      </template>
      <template v-if="!isPursuitsToDeal">
        <div class="info_form">
          <div class="title"><div class="circle"></div>{{$t('deal.addDeal.dealFile.title')}}
            <span style="font-size: 12px;color: #999999;">({{$t('deal.addDeal.dealFile.warning')}})</span>
            <pt-oss-upload inconType="icon-shangchuan" @onSuccess="dealFileUploadSuccess" style="float:right;"></pt-oss-upload>
          </div>
          <div style="background: rgba(248,249,251,0.62);padding:30px 0px;margin-top: 25px;" v-if="dealFile.length == 0">
            <pt-empty style="margin: 0px;width: 100%"><span slot="description">{{$t('deal.addDeal.dealFile.empty')}}</span></pt-empty>
          </div>
          <div v-else style="background: rgba(248,249,251,0.62);padding:30px 0px;">
            <a-row v-for="(file,index) in dealFile" :key="file.id">
              <a-divider v-if="index != 0" style="margin-top: 0;"/>
              <div class="deal_files" :style="index == 0 ? {marginTop: '24px'} : {}">
                <div style="margin-right: 20px;">
                  <pt-icon type="icon-fujian" :styleObj="{fontSize: '22px'}"></pt-icon>
                </div>
                <div style="flex: 1;font-size: 12px;color: #333333;display: flex; align-items: center;">{{file.name}}</div>
                <div style="display: flex;align-items: center;">
                  <div @click="removeFile(file)">
                    <pt-icon type="icon-tubiao" :styleObj="{fontSize: '14px', cursor:'pointer'}"></pt-icon>
                  </div>
                </div>
              </div>
            </a-row>
          </div>
        </div>
      </template>
      <pt-modal :title="customerType == 1 ? customerModalTitle : proprietorModalTitle" :visible="customerModalVisible || proprietorModalVisible"
                @ok="saveCustomer" @cancel="cancelAddCustomer" :width="800"
      >
        <div slot="content">
          <add-customer ref="addCustomerRef" :isPersonl="true" v-model="customerModalTitle" @saveSuccess="saveSuccess" v-if="customerModalVisible"></add-customer>
          <addProprietor v-if="proprietorModalVisible" v-model="proprietorModalTitle" ref="addProprietorRef" @saveSuccess="saveProprietorSuccess"></addProprietor>
        </div>
      </pt-modal>

      <pt-modal :title="$t('baseVO.add') + $t('deal.dealDetails.dealDetail.addOldLease')" :visible="showLeaseContract"
                @ok="saveLease" @cancel="hideLease" :width="800"
      >
        <div slot="content">
          <add-lease :companyShow="companyShow" ref="addLeaseRef" :defaultCustomerId="defaultCustomerId"
                     :defaultLeaseInfoVO="defaultLeaseInfoVO == null ? defaultLeaseInfoVO : defaultLeaseInfoVO.leaseLeaseInfoVO"
                     :defaultRentUnit="defaultRentUnit" :defaultAreaUnit="defaultAreaUnit"
          ></add-lease>
        </div>
      </pt-modal>

      <pt-modal :title="$t('proprietor.selectMansionModal.title')" :visible='selectModel.visable'
                :loading='selectModel.loading'
                @ok='submitEvent' @cancel='cancelEvent' :width='800'>
        <div slot='content'>
          <select-mansion :countNum="3" :radio='false' :mansionList='mansionList' ref='selectMansion'
                          @confirmSelect='confirmSelect'></select-mansion>
        </div>
      </pt-modal>


      <dealPursuitsTable :customerId="customerId" ref="dealPursuitsTableRef" :pursuitsToDealVO="pursuitsToDealVO"></dealPursuitsTable>
    </div>
</template>

<script>
  import { getDatadictChildsByPath,findCascadingData } from '@/api/sys/datadict'
  import dealApi from '@/api/mine/deal'
  import colleagueApi from '@/api/database/colleague'
  import customerApi from '@/api/mine/customer'
  import ownerApi from '@/api/database/owner'
  import addLease from '@/views/database/lease/module/addLease'
  import PtInputNumber from '../../../components/form/inputNumber'
  import AddCustomer from '../../database/customer/module/addCustomer'
  import { getByCompanyIdAndType, unitTypeEnum } from '@/api/manager/unitUse'
  import AddProprietor from '../../database/proprietor/module/addProprietor'
  import pursuitsApi from '@/api/mine/pursuit'
  import dealPursuitsTable from './dealPursuitsTable'
  import selectMansion from '../../database/proprietor/module/selectMansion'
  import addOldLease from "@/views/mine/deal/addOldLease";
  export default {
    name: 'addDeal',
    components:{
      addOldLease,
      dealPursuitsTable,
      AddCustomer,
      PtInputNumber,
      AddProprietor,
      selectMansion,
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes,
      },
      addLease
    },
    props:{
      pursuitsToDealVO:{
        type:Object,
        default: () => { return null }
      },
      leaseVO:{},//租约转交易的租约信息
      dealType:{
        type:String,
        default:['搬迁']
      },
      dealOriginType:{
        type:Number,
        default:1
      },
      customerDetailVO: {}
    },
    data(){
      return {
        columnAUser:null,
        companyNameShort:null,
        currProjectPossible:0,
        dealSourceTypeOptions:[],
        leaseSourceTypeOptions:[],
        defaultCustomerId:null,
        cityDatas:[],
        customerType:1,
        dealFile:[],
        dealAccountList:[],
        dealSourceCascade:null,
        defaultAreaUnit:null,
        defaultRentUnit:null,
        brokerageRatio:0,
        companyShow:true,//是否允许编辑租约公司名称
        defaultDealFormValue:{
          dealType:null,
          projectStages:'1',
          propertyType:'写字楼',
          projectPossible:0,
          demandArea:0,
          budgetRent:0,
          brokerageRatio:0,
          totalBrokerage:0,
          totalBrokerageUnit:null,
          priority:'Column_A',
        },
        defaultLeaseInfoVO: null,
        colleagueList:[],
        dealSourceForm: this.$form.createForm(this,{}),
        // brokerageForm: this.$form.createForm(this,{}),
        dealVOForm: this.$form.createForm(this,{}),
        leaseInfoDOS: [],
        linkManDOForms: [],
        linkManDOForm: this.$form.createForm(this,{}),
        dealSourcePath:'',
        accountList:[],
        dealSourceTypes:[],
        priorityOptions: [],
        dealSourcePaths:[],
        competitors:[],
        propertyTypes:[],
        dealTypes:[],
        dealStages:[],
        areaUnits:[],
        rentUnits:[],
        currencyUnits:[],
        customerList:[],
        linkManDOs:[{},{}],
        showLinkMan: false,
        showLeaseContract: false,
        customerModalVisible: false,
        customerModalTitle:'',
        proprietorModalTitle:'',
        proprietorModalVisible: false,
        selectModel: {
          visable: false,
          loading: false
        },
        mansionList:[],
        mansionOptions:[],
        decorators:{
          targetArea:['targetArea',{rules:[
              // {
              //   validator:(rule,value,cb)=>{
              //     if(!value){
              //       cb()
              //     }else{
              //       if(value.length > 3){
              //         cb(this.$t('deal.addDeal.errorInfo.targetAreaLimit'))
              //       }else{
              //         cb()
              //       }
              //     }
              //   }
              // }
            ]}],
          dealSourceType:[
            'dealSourceVO.sourceType',
            {rules:[{required: true, message:this.$t('deal.addDeal.errorInfo.dealSourceType')}]}
          ],
          dealSourcePersonStringList:[
            'dealSourcePersonStringList',{rules:[
              {required: true, message:this.$t('deal.addDeal.errorInfo.dealSourcePersonStringList')},
              {validator:(rule,value,cb)=>{
                if(value){
                  if(value.length > 3){
                    cb(this.$t('deal.addDeal.errorInfo.dealSourcePersonLimit'))
                  }else{
                    cb()
                  }
                }else{
                  cb()
                }
              }}
              ]
            }
          ],
          mansions: ['mansions', {
            rules: [],
            initialValue: undefined
          }],
          dealSourceTree: [
            'sourceType',{rules:[{required: true, message:this.$t('deal.addDeal.errorInfo.dealSourceTree')}]}
          ],
          dealAccountList: [
            'dealAccountList',{initialValue: [],rules:[{required: true, message:this.$t('deal.addDeal.errorInfo.dealAccountList')}]}
          ],
          customerId:[
            'customerId',{rules:[{required: true, message:this.$t('deal.addDeal.errorInfo.customerId')}]}
          ],
          customerName:[
            'customerName',{rules:[{ message:this.$t('deal.addDeal.errorInfo.customerId')}]}
          ],
          customerType:[
            'customerType',{initialValue: 1}
          ],
          demandArea:[
            'demandArea',{rules:[]}
          ],
          demandAreaUnit:[
            'demandAreaUnit',{}
          ],
          budgetRent:[
            'budgetRent',{rules:[]}
          ],
          budgetRentUnit:[
            'budgetRentUnit',{}
          ],
          priority:[
            'priority',{}
          ],
          projectEndtime:[
            'projectEndtime',{rules:[{required:true, message:this.$t('deal.addDeal.errorInfo.projectEndtime')}]}
          ],
          projectName:[
            'projectName',{rules:[{max: 100, message:this.$t('deal.addDeal.errorInfo.projectNameMaximum')}]}
          ],
          demandType:[
            'demandType',{}
          ],
          dealType:[
            'dealType',{rules:[{required:true, message:this.$t('deal.addDeal.errorInfo.dealType')}]}
          ],
          projectStages:[
            'projectStages',{}
          ],
          projectPossible:[
            'projectPossible',{}
          ],
          competitionSituation:[
            'competitionSituation',{}
          ],
          mansion:[
            'mansion',{}
          ],
          floor:[
            'floor',{}
          ],
          unitCode:[
            'unitCode',{}
          ],
          leaseArea:[
            'leaseArea',{}
          ],
          leaseAreaUnit:[
            'leaseAreaUnit',{}
          ],
          rent:[
            'rent',{}
          ],
          rentUnit:[
            'rentUnit',{}
          ],
          startTime:[
            'startTime',{}
          ],
          endTime:[
            'endTime',{}
          ],
          propertyType:[
            'propertyType',{}
          ],
          totalBrokerage:[
            'totalBrokerage',{rules:[]}
          ],
          brokerageRatio:[
            'brokerageRatio',{rules:[]}
          ],
          totalBrokerageUnit:[
            'totalBrokerageUnit',{}
          ],
          remarks:[
            'remarks',{rules:[{max: 500, message:this.$t('deal.addDeal.errorInfo.remarksMaximum')}]}
          ],
        }
      }
    },
    watch:{
      'customerDetailVO.id'(){

        this.init()
      }
    },
    computed:{
      isPursuitsToDeal(){
        return this.pursuitsToDealVO != null
      },
      isServiceDeal(){
        if(this.dealOriginType == 2){
          return true
        }else{
          return false
        }
      }
    },
    mounted(){
      this.init()
    },
    methods:{
      toChinesNum(num) {
        let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] //changeNum[0] = "零"
        let unit = ['', '十', '百', '千', '万']
        num = parseInt(num)
        let getWan = (temp) => {
          let strArr = temp.toString().split('').reverse()
          let newNum = ''
          for (var i = 0; i < strArr.length; i++) {
            newNum = (i == 0 && strArr[i] == 0 ? '' : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? '' : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum
          }
          return newNum
        }
        return getWan(num)
      },
      mansionChange(value) {
        console.log('mansionList', this.mansionList)
        console.log('value', value)
        for (var i = 0; i < this.mansionList.length; i++) {
          let indexOf = value.indexOf(this.mansionList[i].id)
          if (indexOf == -1) {
            this.mansionList.splice(i, 1)
            i--
          }
        }
        this.fillMansionOptions()
      },
      fillMansionOptions() {
        this.mansionOptions = []
        this.mansionList.forEach(data => {
          let mansionOption = {
            name: data.name,
            id: data.id
          }
          this.mansionOptions.push(mansionOption)
        })
      },
      submitEvent() {
        this.$refs.selectMansion.confirmSelect()
      },
      openSelectMansion() {
        this.selectModel.visable = true
      },
      cancelEvent() {
        this.selectModel.visable = false
      },
      confirmSelect(mansionList) {
        this.mansionList = mansionList
        this.mansionOptions = []
        let mansionIds = []
        this.mansionList.forEach(item => {
          this.mansionOptions.push({ id: item.id, name: item.name })
          mansionIds.push(item.id)
        })
        this.$nextTick(() => {
          this.dealVOForm.setFieldsValue({ mansions: mansionIds })
        })
        this.cancelEvent()
      },
      disabledMonthDate(current){
        //禁用当前月之前的日期
        return current && current <= this.$moment().month(this.$moment().month() - 1).endOf('month');
      },
      saveProprietorSuccess(id,name,owner){
        this.proprietorModalVisible = false
        this.customerList = [];
        let ownerDO = {
          id:id,
          companyName:name,
          companySortNameCn: owner.companySortNameCn
        }
        this.customerList.push(ownerDO);
        this.dealVOForm.setFieldsValue({
          customerId: id
        })

        this.buildProjectNameByCustomer(id)
      },
      customerTypeChange(value){
        this.customerType = value.target.value
        this.dealVOForm.setFieldsValue({customerId:undefined})
        this.customerList = []
      },
      setPursuitsToDealDefaultValue(){
        this.initCustomerList()
        if(this.pursuitsToDealVO.projectEndtime == '~'){
          this.pursuitsToDealVO.projectEndtime = undefined
        }
        this.dealSourceForm.setFieldsValue(this.pursuitsToDealVO)

        this.colleagueList = this.pursuitsToDealVO.colleagueDOS != null ? this.pursuitsToDealVO.colleagueDOS.map(e=>{
          return e.id
        }) : []
        this.$refs.dealPursuitsTableRef.queryDealPursuitsList(this.pursuitsToDealVO.customerId,1)
        // this.getColumnACustomerFollower(this.pursuitsToDealVO.customerId)
        //
        if(this.pursuitsToDealVO.targetArea != '~'){
          this.pursuitsToDealVO.targetArea = JSON.parse(this.pursuitsToDealVO.targetArea)
        }else{
          this.pursuitsToDealVO.targetArea = null
        }
        this.mansionList = this.pursuitsToDealVO.mansionList;
        this.mansionOptions = this.pursuitsToDealVO.mansionList;
        this.pursuitsToDealVO.priority = 'Column_A';
        this.dealVOForm.setFieldsValue(Object.assign(this.defaultDealFormValue,this.pursuitsToDealVO))
      },
      submitPursuitsTransferToDeal(){
        let validatePass = true
        this.dealSourceForm.validateFields(err=>{
          if(err){
            validatePass = false
          }
        })
        this.dealVOForm.validateFields(err=>{
          if(err){
            validatePass = false
          }else{

          }
        })
        this.linkManDOForm.validateFields(err=>{
          if(err){
            validatePass = false
          }
        })

        if(validatePass){
          let dealSourceVO = this.dealSourceForm.getFieldsValue()
          dealSourceVO.dealSourcePersonDOS = dealSourceVO.dealSourcePersonStringList.map(e=>{return {userId:e}})
          let dealVO = this.dealVOForm.getFieldsValue()
          dealVO.linkmanDOS = this.linkManDOForm.getFieldsValue().linkmanDOS
          dealVO.projectPossible = this.currProjectPossible;
          let dealAccountList = dealSourceVO.dealAccountList
          dealVO.dealAccountVOS = dealAccountList.map(e=>{
            return {accountId: e}
          })
          dealVO.dealSourceVO = dealSourceVO
          dealVO.pursuitsId = this.pursuitsToDealVO.pursuitsId
          dealVO.dealOriginType = this.dealOriginType
          if(dealVO.dealOriginType == 1){
            if(typeof dealVO.dealType != 'string'){
              dealVO.dealType = dealVO.dealType.join(',')
            }
          }else{

          }
          pursuitsApi.transferTransaction(dealVO).then(res=>{
            if(res.code == 1){
              this.$message.success(res.message)
              this.$emit('transferSuccess')
            }else{
              this.$message.error(res.message)
              this.$emit('validateFail')
            }
          })
        }else{
          this.$emit('validateFail')
        }
      },
      saveSuccess(id,name,customer){
        this.customerList = [];
        let customerDO = {
          id:id,
          companyName:name,
          companySortNameCn: customer.companySortNameCn
        }
        this.defaultCustomerId = id
        this.customerList.push(customerDO);
        this.dealVOForm.setFieldsValue({
          customerId: id
        })
        this.customerModalVisible = false;
        this.buildProjectNameByCustomer(id)
      },
      addLinkMan(){
        this.linkManDOForms.push({})
      },
      buildProjectNameByCustomer(customerId){
        this.defaultCustomerId = customerId
        let customerDO = this.customerList.find(e=>{return e.id == customerId})
        let dealTypeIds = this.dealVOForm.getFieldValue('dealType')
        let dealType = ''
        for(let i = 0; i < dealTypeIds.length; i++){
          dealType += this.$t('deal.dealTypes')[dealTypeIds[i]]
        }
        this.dealVOForm.setFieldsValue({projectName: customerDO.companySortNameCn + dealType})
        this.companyNameShort = customerDO.companySortNameCn;
        this.$refs.dealPursuitsTableRef.queryDealPursuitsList(customerId,this.customerType)
        // if(this.customerType == 1){
        //   this.getColumnACustomerFollower(customerId)
        // }
      },
      buildProjectNameByDealType(dealTypeIds){
        let customerDO = this.customerList.find(e=>{return e.id == this.dealVOForm.getFieldValue('customerId')})
        let dealType = ''
        for(let i = 0; i < dealTypeIds.length; i++){
          dealType += this.$t('deal.dealTypes')[dealTypeIds[i]]
        }
        this.dealVOForm.setFieldsValue(
          {
            projectName: customerDO ? customerDO.companyName + dealType : '',
            dealType: dealTypeIds
          }
          )
      },
      changeBrokerageRatio(){
        this.currProjectPossible = this.$refs.possibleSliderRef.currStep;
        this.brokerageRatio = this.$refs.possibleSliderRef.currStep;
      },
      changePossible(){
        this.currProjectPossible = this.$refs.possibleSliderRef.currStep;
      },
      cancelAddCustomer(){
        this.proprietorModalVisible = false
        this.customerModalVisible = false;
      },
      dealFileUploadSuccess(file,fileId,number){
        this.dealFile.push(Object.assign(file,{dealFileDO:{fileId:fileId}}))
      },
      initServiceDealSourceTypes(){
        console.log("-=-=-=-=-=-")
        let this_ = this
        getDatadictChildsByPath('system.business_key.deal_source_set').then(res=>{
          this_.dealSourceTypeOptions = res.data.filter(e=>{return e.wordKey == 'approach' || e.wordKey == 'invited'})
          this_.leaseSourceTypeOptions = res.data.filter(e=>{return e.wordKey != 'approach' && e.wordKey != 'invited'})
        })
      },
      deleteLinkman(index){
        this.linkManDOForms = this.linkManDOForm.getFieldsValue().linkmanDOS
        if(this.linkManDOForms.length==1){
          this.$message.warning(this.$t('deal.addDeal.needOne'))
          return
        }else{
          this.linkManDOForms.splice(index,1)
          this.$nextTick(()=>{
            this.linkManDOForm.setFieldsValue({linkmanDOS:this.linkManDOForms})
          })
        }
      },
      hideLease(){
        this.showLeaseContract = false
      },
      hideLinkManForm(){
        this.showLinkMan = false;
        this.linkManDOForms = []
      },
      handleSearch(companyName){
        setTimeout(()=>{
          let this_ = this
          let p = new Promise((resolve, reject)=>{
            if(this_.customerType == 1){
              customerApi.queryByName({name:companyName}).then(res=>{
                if(res.code == 1){
                  this.customerList = res.data != null ? res.data : []
                  resolve()
                }else{
                  reject()
                }
              })
            }else{
              ownerApi.queryByName({name:companyName}).then(res=>{
                if(res.code == 1){
                  this.customerList = res.data != null ? res.data : []
                  resolve()
                }else{
                  reject()
                }
              })
            }
          })
          return p
        },300);
      },
      handleSearchById(id) {
        console.log("handleSearchById",id)
        let this_ = this
        customerApi.selectOne(id).then(res => {
          this_.dealVOForm.setFieldsValue({
            customerId: res.data.id,
            customerName: res.data.companyName,
          })
          this.companyNameShort = res.data.companySortNameCn;
          console.log(this_.dealVOForm.getFieldsValue())
          // console.log("this_.trackForm.",this_.trackForm.getFieldsValue())
          this_.customerList.push(res.data)
          console.log(this_.customerList)
        })
      },
      getColumnACustomerFollower(customerId){
        customerApi.getColumnACustomerFollower(customerId).then(res=>{
          if(res.code == 1){
            if(res.data != '~'){
              let userBO = res.data
              let userName = userBO.accountDO.loginName
              let accountId = userBO.accountDO.id
              this.columnAUser = accountId
              let customerDO = this.customerList.find(e=>{return e.id == customerId})
              let message = customerDO.companySortNameCn +
                this.$t('deal.addDeal.addFollowerFront') + userName +
                this.$t('deal.addDeal.addFollowerMiddle') + userName +
                this.$t('deal.addDeal.addFollowerEnd')
              this.$message.warning(message)
              if(!this.isServiceDeal){
                let dealAccountList = this.dealSourceForm.getFieldsValue().dealAccountList
                if(dealAccountList.indexOf(accountId) < 0){
                  dealAccountList.push(accountId)
                  this.dealSourceForm.setFieldsValue(
                    {
                      dealAccountList: dealAccountList
                    }
                  )
                }
              }else{
                let dealAccountList = this.dealVOForm.getFieldsValue().dealAccountList
                if(dealAccountList.indexOf(accountId) < 0){
                  dealAccountList.push(accountId)
                  this.dealVOForm.setFieldsValue(
                    {
                      dealAccountList: dealAccountList
                    }
                  )
                }
              }
            }
          }
        })
      },
      init(){
        if(!this.isPursuitsToDeal){
          this.initDealAccount()
        }
        if(this.leaseVO){
          // this.getColumnACustomerFollower(this.leaseVO.customerId)
          this.fillDealForm();//租约转交易填充要保存的数据
        }
        if(this.dealOriginType == 1){
          this.initCityData()
        }
        if(this.customerDetailVO){
          console.log('交易------', this.customerDetailVO)
          this.handleSearchById(this.customerDetailVO.id)
          // this.buildProjectNameByCustomer(this.customerDetailVO.id)
        }
        this.initCustomerRelationShipOptions()
        this.initCompetitors()
        this.initDealTypes()
        this.initPropertyTypes()
        this.initDealStages()
        this.initDefaultUnit()
        this.initServiceDealSourceTypes()
        this.showLinkManForm();
      },
      initCustomerList(){
        customerApi.selectOne(this.pursuitsToDealVO.customerId).then(res=>{
          this.companyNameShort = res.data.companySortNameCn;
          this.customerList.push(res.data)
        })
      },
      initCustomerRelationShipOptions(){
        customerApi.getCustomerRelationShipOptions().then(res=>{
          if(res.code == 1){
            this.priorityOptions = res.data
            this.priorityOptions.sort((a,b)=>{
              return a.listIndex - b.listIndex
            })
          }
        })
      },
      initDealAccount(){
        // let accountList = [this.$store.getters.userInfo.accountDO.id]
        this.$nextTick(()=>{
          if(this.isServiceDeal){
            let accountList = this.dealVOForm.getFieldsValue().dealAccountList
            accountList.push(this.$store.getters.userInfo.accountDO.id)
            this.dealVOForm.setFieldsValue({dealAccountList:accountList})
          }else{
            let accountList = this.dealSourceForm.getFieldsValue().dealAccountList
            accountList.push(this.$store.getters.userInfo.accountDO.id)
            this.dealSourceForm.setFieldsValue({dealAccountList:accountList})
          }
        })
      },
      fillDealForm(){
        this.customerList = [];
        var customerDO = {
          companyName:this.leaseVO.companyName,
          companySortNameCn:this.leaseVO.companyShortNameCN,
          id:this.leaseVO.customerId
        }
        this.customerList.push(customerDO);
        let dealTypeIds = this.dealType
        let dealType = ''
        for(let i = 0; i < dealTypeIds.length; i++){
          dealType += this.$t('deal.dealTypes')[dealTypeIds[i]]
        }
        this.dealVOForm.setFieldsValue({
          customerId: this.leaseVO.customerId,
          projectName: customerDO.companyName + dealType,
          demandArea: this.leaseVO.leaseArea,
          demandAreaUnit: this.leaseVO.leaseAreaUnit,
          budgetRent:this.leaseVO.rent,
          budgetRentUnit:this.leaseVO.rentUnit
        })
        if(this.leaseVO.colleagueDOS){
          this.leaseVO.colleagueDOS.forEach(c=>{
            this.colleagueList.push(c.id);
          })
        }
        let temp = JSON.stringify(this.leaseVO)
        this.leaseInfoDOS.push({newLease:false, leaseLeaseInfoVO: JSON.parse(temp.replace(/\"~\"/g,null))})
        this.$refs.dealPursuitsTableRef.queryDealPursuitsList(this.leaseVO.customerId,1)
      },
      initDefaultUnit(){
        Promise.all([this.initDefaultCurrencyUnit(),this.initDefaultAreaUnit(),this.initDefaultRentUnit()]).then(()=>{
          this.initDefaultValue()
        })
      },
      initDefaultCurrencyUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.CURRENCY).then(res=>{
            if(res.code == 1){
              this.defaultDealFormValue.totalBrokerageUnit = res.data[0]
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initDefaultAreaUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.AREA).then(res=>{
            if(res.code == 1){
              this.defaultDealFormValue.demandAreaUnit = res.data[0]
              this.defaultAreaUnit = res.data[0]
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initDefaultRentUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.RENT).then(res=>{
            if(res.code == 1){
              this.defaultDealFormValue.budgetRentUnit = res.data[0]
              this.defaultRentUnit = res.data[0]
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initCityData(){
        let this_ = this
        findCascadingData("system.mansion_set.address",4).then(res=>{
          let data
          for(let i = 0; i < res.data.length; i++){
            //只显示员工公司所在
            data = this_.buildNewTree(res.data[i],this_.$store.getters.userInfo.companyDO.city.toLowerCase())
            if(data){
              break
            }
          }
          this_.cityDatas = data
        })
      },
      buildNewTree(tree,equalsValue){
        let stack = [tree]
        if(tree.value != equalsValue){
          for(let i = 0; i < tree.children.length; i++){
            if(tree.children[i].value == equalsValue){
              return stack
            }
          }
        }else{
          return stack
        }
      },
      initDefaultValue(){
        this.defaultDealFormValue.dealType = this.dealType
        if(this.isPursuitsToDeal){
          this.setPursuitsToDealDefaultValue()
        }else{
          this.dealVOForm.setFieldsValue(this.defaultDealFormValue)
        }
        this.currProjectPossible = this.defaultDealFormValue.projectPossible;
      },
      initCompetitors(){
        colleagueApi.selectAll().then(res=>{
          if(res.code == 1){
            this.competitors = res.data.records
          }
        })
      },
      initPropertyTypes(){
        let propertyTypes = this.$t('deal.propertyTypes')
        for(var p in propertyTypes){
          this.propertyTypes.push({wordKey:p,wordValue:propertyTypes['' + p]})
        }
      },
      initDealTypes(){
        let dealTypes = this.$t('deal.dealTypes')
        for(var p in dealTypes){
          if(p != '项目咨询与顾问'){
            this.dealTypes.push({wordKey:p,wordValue:dealTypes['' + p]})
          }
        }
      },
      initDealStages(){
        if(!this.isServiceDeal){
          getDatadictChildsByPath('system.business_key.leaseProjectStages').then(res=>{
            this.dealStages = res.data.filter(e=>{return e.wordKey != 12 && e.wordKey != 13})
          })
          this.defaultDealFormValue.projectStages = '7'
        }else{
          getDatadictChildsByPath('system.business_key.consultantProjectStages').then(res=>{
            this.dealStages = res.data.filter(e=>{return e.wordKey != 12 && e.wordKey != 13})
          })
          this.defaultDealFormValue.projectStages = '1'
        }
      },
      openAddCustomerModal(){
        if(this.customerType == 1){
          this.customerModalVisible = true;
        }else{
          this.proprietorModalVisible = true
        }
      },
      removeFile(file){
        this.dealFile.splice(this.dealFile.indexOf(file),1)
      },
      saveCustomer(){
        if(this.customerType == 1) {
          this.$refs.addCustomerRef.submit()
        }else{
          this.$refs.addProprietorRef.submit()
        }
      },
      //获取原租约数据
      saveLease(){
        if(!this.isServiceDeal){
          let leaseInfoVO = this.$refs.oldLeaseRef.extractLeaseInfoVO()
          if(!leaseInfoVO){
            return
          }

          if(this.defaultLeaseInfoVO){
            this.leaseInfoDOS[this.leaseInfoDOS.indexOf(this.defaultLeaseInfoVO)] = {newLease:false, leaseLeaseInfoVO: leaseInfoVO}
          }else{
            this.leaseInfoDOS = [];
            this.leaseInfoDOS.push({newLease:false, leaseLeaseInfoVO: leaseInfoVO})
          }
        }

      },
      showLease(leaseInfoVO){
        if(this.leaseVO){
          this.companyShow = false;
        }
        this.showLeaseContract = true
        this.defaultLeaseInfoVO = leaseInfoVO
      },
      showLinkManForm(){
        this.showLinkMan = true
        this.addLinkMan()
      },
      submit(){
        this.saveLease();
        let validatePass = true
        let dealVO
        if(!this.isServiceDeal){
        this.dealSourceForm.validateFields(err=>{
          if(err){
            validatePass = false
          }
        })
        this.dealVOForm.validateFields(err=>{
          if(err){
            validatePass = false
          }else{

          }
        })
        let dealSourceVO = this.dealSourceForm.getFieldsValue()
        dealSourceVO.dealSourcePersonDOS = dealSourceVO.dealSourcePersonStringList ? dealSourceVO.dealSourcePersonStringList.map(e=>{return {userId:e}}) : []

        dealVO = this.dealVOForm.getFieldsValue()
        dealVO.projectPossible = this.currProjectPossible
        dealVO.leaseLeaseInfoTypeVOS = this.leaseInfoDOS
        dealVO.colleagueDOS = this.colleagueList.map(e=>{
          return {id: e}
        })
        let dealAccountList = dealSourceVO.dealAccountList
        if(this.columnAUser){
          if(dealAccountList.indexOf(this.columnAUser) < 0){
            this.$message.error(this.$t('deal.addDeal.errorInfo.missingColumnAUser'))
            validatePass = false
          }
        }
        dealVO.dealAccountVOS = dealAccountList.map(e=>{
          return {accountId: e}
        })
        this.linkManDOForm.validateFields(err=>{
          if(err){
            validatePass = false
          }
        })
        dealVO.linkmanDOS = this.linkManDOForm.getFieldsValue().linkmanDOS
        dealVO.dealSourceVO = dealSourceVO
        }else{
          this.dealVOForm.validateFields(err=>{
            if(err){
              validatePass = false
            }else{

            }
          })
          dealVO = this.dealVOForm.getFieldsValue()
          dealVO.projectPossible = this.currProjectPossible;
          dealVO.linkmanDOS = this.linkManDOForm.getFieldsValue().linkmanDOS
          let dealAccountList = dealVO.dealAccountList
          dealVO.dealAccountVOS = dealAccountList.map(e=>{
            return {accountId: e}
          })
        }
        this.linkManDOForms.length > 0 && this.linkManDOForm.validateFieldsAndScroll(err=>{
          if(err){
            validatePass = false
          }
        })
        if(validatePass){
          dealVO.dealFileVOS = this.dealFile
          dealVO.dealOriginType = this.dealOriginType
            dealVO.dealType = dealVO.dealType.join(',')
          if(dealVO.targetArea){
            dealVO.targetArea = JSON.stringify(dealVO.targetArea)
          }
          dealApi.insert(dealVO).then(res=>{
            if(res.code == 1){
              this.$message.success(res.message)
              this.$emit('saveSuccess')
            }else{
              this.$emit('saveFail')
              this.$emit('validateFail')
            }
          })
        }else{
          this.$emit('validateFail')
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../../core/diy.less';
  #addDeal{
    .blackhillsYellow{
      color: @blackhills-yellow;
    }
    .background_color{
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
    }
    .slider-wrapper{
      display: flex;
      margin-top: 12px;
    }
    .expandMoreDiv{
      margin-bottom: 16px;
      background: rgba(248,249,251,0.62);
      border-radius: 2px;
      position: relative;
      .closeExpandBtn{
        z-index: 10;
        position: absolute;
        right: 0px;
        top:0px;
        width: 24px;
        height: 24px;
        border-radius:2px;
        background: #D3D3D3;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        .closeIcon{
          font-size: 14px;
          color: #FFFFFF;
        }
      }
    }
    .deal_files{
      display: flex;
      flex-direction: row;
    }
    .circle{
      margin-right: 12px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #FABE00;
      display: inline-block;
    }
    .title{
      font-size: 14px;
      color: #333333;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .ant-row{
      padding: 10px;
      border-radius: 0 0 4px 4px;
      margin-bottom: 0;
    }
    .info_form{
      margin-bottom:20px;
    }
    .delete_icon{
      color: #8E8E8E;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .addCustomerBtn{
    background: #3B2E26;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 30px;
    .addIcon{
      color: #ffffff;
      font-size: 12px;
    }
  }
  .lease_info{
    .lease_title{
      flex: 1;
      font-size: 14px;
      color: #333333;
      font-weight: bold;
    }
    position: relative;
    margin-bottom: 5px;
    background: rgba(248,249,251,0.62);
    padding: 10px 20px;
    .edit_icon{
      font-size: 18px;
    }
  }
  .ant-select-dropdown-content{
    /deep/.invisible-item{
      display:initial !important;
    }
  }
  /deep/.invisible-item{
    display:none;
  }
  .deal_cascader{
    /deep/ .el-input__inner{
      padding-left:4px !important;
    }
  }
</style>